export default __webpack_public_path__ + "static/media/PST-GIF.9e372ce1.gif";